import Score from "./Score";
import POIs from "./Score/POIs";
import * as S from "./styles";
import {
  Spacer,
  LoadingSpinner,
  Text,
  LoadingItem,
} from "@local-logic/core/ui";
import {
  ScoreCategoryTabs,
  scoreCategories,
  scorePois,
} from "@local-logic/elements-react";
import React, { useEffect } from "react";
import { useLangauges, LCTranslationKeys } from "~/context/languageProvider";
import { useStateManagerContext } from "~/context/stateManager";
import useFilterSortScores from "~/hooks/useFilterSortScores";
import { useLocalContent } from "~/sdks/LocalContent/context";
import { LocalContentProps } from "~/sdks/LocalContent/types";

interface ScoreCategoryProps {
  tabContent: (typeof scoreCategories)[number];
}

const ScoreCategory = React.memo(({ tabContent }: ScoreCategoryProps) => {
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const { setActiveScore, hasFilteredPOIs } = useLocalContent();

  const { cleanScores, data, isLoading, isFetching } = useFilterSortScores(
    tabContent.scores
  );

  useEffect(() => {
    if (cleanScores.length > 0) {
      setActiveScore(cleanScores[0]);
    }
  }, [cleanScores]);

  const { translations } = useLangauges<LCTranslationKeys>();

  return (
    <S.ScoreCategory>
      <S.TitleContainer>
        <ScoreCategoryTabs.Title
          options={{
            variant: "h4",
            noMargin: true,
            weight: "--ll-font-weight-medium",
          }}
        />
        {isFetching && isLoading && <LoadingSpinner size="small" />}
      </S.TitleContainer>
      <Spacer spacing="--ll-spacing-small" vertical />
      {!isFetching && cleanScores.length === 0 && !hasFilteredPOIs && (
        <Text color="--ll-color-on-background-variant1">
          {translations.NO_RESULTS_WITHIN_RADIUS}
        </Text>
      )}

      {isFetching && isLoading && (
        <S.LoadingItemContainer>
          <LoadingItem height="34px" width="100%" />
        </S.LoadingItemContainer>
      )}

      {cleanScores.map((score) => (
        <Score key={score} score={score} scoresData={data} />
      ))}

      {!isFetching && hasFilteredPOIs && !cleanScores.length && (
        <S.POIContainer>
          <POIs include={scorePois[tabContent.scores[0]]!} />
        </S.POIContainer>
      )}
    </S.ScoreCategory>
  );
});

ScoreCategory.displayName = "ScoreCategory";

export default ScoreCategory;
